import translate from 'helpers/translate'
import React, { Fragment } from 'react'
import { Link } from 'react-router-dom'
import useAuth from 'store/AuthContext'
import useConfig from 'store/ConfigProvider'
import {
  CopyrightText,
  FooterContact,
  FooterContainer,
  FooterGeneralInfo,
  FooterLogo,
  FooterMenu,
  FooterPhone,
  FooterTop,
} from './Footer.style'

const Footer = props => {
  const { settings, footer, isLoaded } = useConfig()
  const { setLoginModalShow, auth } = useAuth()

  const handleMyProfileClick = e => {
    if (!auth) {
      e.preventDefault()
      setLoginModalShow(true)
    }
  }
  const handleMyOrdersClick = e => {
    if (!auth) {
      e.preventDefault()
      setLoginModalShow(true)
    }
  }

  if (!isLoaded) return null

  return (
    <FooterContainer>
      <FooterTop>
        <FooterGeneralInfo>
          <FooterLogo to="/">
            <img
              alt="Cosmo"
              width="50"
              height="50"
              src="/img/cosmo.png"
            />
          </FooterLogo>
          <FooterPhone>
            <p>{translate('contactUs')}:</p>
            <h4>{settings.phone_number}</h4>
          </FooterPhone>
          <FooterContact>
            <strong>{translate('workingHours')}:</strong>
            <p>
              Everyday
              <br />
              Sat: 10:00-15:00
              <br />
            </p>
            <strong>{translate('address')}:</strong>
            <address>
              Vazha Pshavela Ave #16a,
              <br />
              Tbilisi,Georgia 0192
            </address>
          </FooterContact>
          <div className="flex">
            <div id="google_translate_element"></div>
            <span
              className="return-language-text"
              // onClick={showLanguageBar}
              style={{ cursor: 'pointer', marginLeft: 10, color: 'white' }}
            >
              Returns
            </span>
          </div>
        </FooterGeneralInfo>

        <div className="flex flex-col md:flex-row">
          {(footer || []).map((footer, footer_key) => {
            if (!Array.isArray(footer.children) && !footer.children.count)
              return null
            return (
              <FooterMenu key={footer.id}>
                <h4>{footer.title.replace('ციტრუს', 'კოსმო')}</h4>
                <ul>
                  <ul>
                    {footer_key === 2 ? (
                      <Fragment>
                        <li>
                          <Link
                            to="/account/orders"
                            onClick={handleMyProfileClick}
                          >
                            My Profile
                          </Link>
                        </li>
                        <li>
                          <Link
                            onClick={handleMyOrdersClick}
                            to="/account/orders"
                          >
                            My Orders
                          </Link>
                        </li>
                      </Fragment>
                    ) : null}
                    {footer.children.map((child, key) => {
                      return (
                        <li key={child.id}>
                          <Link to={child.url || ''}>
                            {child.title.replace('ციტრუს', 'კოსმო') || ''}
                          </Link>
                        </li>
                      )
                    })}
                  </ul>
                </ul>
              </FooterMenu>
            )
          })}
        </div>
      </FooterTop>
      <div className="footer flex flex-col md:flex-row pt-4 justify-between gap-y-4 gap-x-4 md:pr-10">
        <div className="footer-payment justify-center flex flex-row gap-x-4">
          <img alt="tbc" src="/img/tbc.jpg" />
          <img alt="credo" src="/img/credo.jpg" />
          <a
            href="//www.dmca.com/Protection/Status.aspx?ID=b90b506b-1a6c-40ac-9116-683e00eb0942"
            title="DMCA.com Protection Status"
            className="dmca-badge"
          >
            <img
              src="https://images.dmca.com/Badges/dmca_protected_sml_120s.png?ID=b90b506b-1a6c-40ac-9116-683e00eb0942"
              alt="DMCA.com Protection Status"
            />
          </a>
          <script src="https://images.dmca.com/Badges/DMCABadgeHelper.min.js"></script>
        </div>
        <div className="footer-social justify-center flex flex-row gap-x-4">
          <a
            rel="noopener noreferrer"
            target="_blank"
            href="https://www.facebook.com/www.cosmo.ge"
          >
            <img alt="facebook" src="/img/facebook.svg" />
          </a>
        </div>
      </div>
      <CopyrightText>
        <p>{translate('footerText')}</p>
      </CopyrightText>
    </FooterContainer>
  )
}

export default Footer
